import {Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nns-workspace-select',
  template: `
    <div class="nns-organization-select">
      <div class="nns-select" (clickOutside)="isShowDropdown = false">
        <div class="nns-select-item--wrapper" (click)="onToggleDropdown()">
          <nns-workspace-select-item
            *ngIf="selectedWorkspace"
            [ngClass]="{'nns-select-item__disabled': !workspaces || (workspaces && workspaces.length == 1)}"
            [workspace]="selectedWorkspace"
            [isOwner]="selectedWorkspace.userId == ownerId"
            [hasArrow]="workspaces && workspaces.length > 1"
            ></nns-workspace-select-item>
        </div>

        <div class="nns-select-dropdown" *ngIf="isShowDropdown">
          <nns-workspace-select-item
            *ngFor="let workspace of workspaces" (click)="onSelectWorkspace(workspace)"
            [ngClass]="{'active': selectedWorkspace && selectedWorkspace.globalId == workspace.globalId}"
            [workspace]="workspace"
            [isOwner]="workspace.userId == ownerId"
            ></nns-workspace-select-item>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .nns-select{
      position: relative;
    }

    .nns-select-dialog-title{
      font-size: 13px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.87);
    }

    .nns-header-profile-button-active /deep/ .nns-header-profile-arrow {
      border-top:none;
      border-bottom:4px solid rgba(0, 0, 0, 0.6);
    }

    .nns-select-dropdown{
      margin-top: 1px;
      position: absolute;
      left: 0;
      top: 100%;
      background-color: #fff;
      box-shadow: 0px 9px 14px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      width: 100%;
      max-height: 300px;
      overflow: hidden;
      overflow-y: auto;
      z-index: 1;
    }

    .nns-workspace-select-list{
      display: flex;
      flex-direction: column;
      max-height: 238px;
      overflow-x: auto;
      padding-right: 8px;
      padding-bottom: 8px;
    }
  `, `
  :host-context(.nns-theme-night) .nns-select-dropdown {
    background: #292E32;
    box-shadow: 4px 4px 38px rgba(19, 30, 32, 0.66);
  }
`
  ]
})

export class WorkspaceSelectComponent {
  @Input() workspaces;
  @Input() selectedWorkspace;
  @Input() ownerId;
  @Output() onSelectWorkspaceEvent: EventEmitter<string> = new EventEmitter<string>();

  isShowDropdown: boolean;

  constructor() {}

  onToggleDropdown() {
    if(this.workspaces && this.workspaces.length > 1) {
      this.isShowDropdown = !this.isShowDropdown;
    }
  }

  onSelectWorkspace(workspace) {
    this.onSelectWorkspaceEvent.emit(workspace.globalId);
    this.isShowDropdown = false;
  }

}
